import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * shadcn/ui input — a styled `<input>`, no Radix, no dependency.
 *
 * Used only where the surrounding surface is shell chrome (the ⌘K palette). Data-entry
 * forms use AntD's `Input`, per CLAUDE.md §8's split, because they need `Form.Item`,
 * validation state and the zod bridge in `lib/zodForm.ts`.
 */
export const Input = ({ className, type, ...props }: ComponentProps<'input'>) => (
  <input
    type={type}
    className={cn(
      'flex h-[var(--control-height)] w-full rounded-md border border-border-strong bg-transparent px-3 py-1 text-sm',
      'transition-colors placeholder:text-subtle focus-visible:border-primary focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
);
